module.exports = __webpack_public_path__ + "static/media/je.6ab08614.svg";